import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { PtpDateBasedComponent } from './ptp-date-based/ptp-date-based.component';
import { ArrangementDateBasedComponent } from './arrangement-date-based/arrangement-date-based.component';

@Component({
	selector: 'app-ptp-date-report',
	templateUrl: './ptp-date-report.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./ptp-date-report.component.scss'],
	imports: [
		MatTabGroup,
		MatTab,
		PtpDateBasedComponent,
		ArrangementDateBasedComponent,
	],
})
export class PtpDateReportComponent {}
